import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {SportHomePageContent} from "../../Common/pages/SportHomePageContent";

export default class BoxingHomePage extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="boxing"
      title="Boxing News & Betting Odds"
      location={ location }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/Boxing/containers/BoxingHomePage.js